export const LOGIN_ROUTE: string = '/';
export const HOMEPAGE_ROUTE: string = '/home';
export const LOGOUT_ROUTE: string = '/logout';
export const PROFILE_ROUTE: string = '/profile';
export const CREATE_PASSWORD_ROUTE: string = '/create-password';
export const RESET_PASSWORD_ROUTE: string = '/reset-password';
export const RECOVERY_PASSWORD_ROUTE: string = '/recovery-password';
export const USERS_ROUTE: string = '/users';
export const ORGANIZATIONS_ROUTE: string = '/organizations';
export const APPS_ROUTE: string = '/applications';
export const UPDATE_PROFILE_ROUTE: string = '/update-profile';
export const UPDATE_PASSWORD_PROFILE_ROUTE = `${UPDATE_PROFILE_ROUTE}/password`;
